import React from "react";
import PropTypes from "prop-types";

class FaqListItem extends React.Component {
  render() {
    const { data } = this.props;
    return (
      <div className="faq-list-item-container">
        <div className="faq-list-item-container-question">
          <img alt="" src={require("@/assets/images/ic_q.svg")} />
          <div>{data.question}</div>
        </div>
        <div className="faq-list-item-container-answer">
          <img alt="" src={require("@/assets/images/ic_a.svg")} />
          <div
            dangerouslySetInnerHTML={{
              __html: data.answer,
            }}
          />
        </div>
      </div>
    );
  }
}

FaqListItem.propTypes = {
  data: PropTypes.shape({
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired,
  }).isRequired,
};

export default FaqListItem;
